<template>
  <header class="flex flex-col items-center md:flex-row md:justify-between mb-6 space-y-4 md:space-y-0">
    <!-- Next Recording (Order 3 on mobile, 1 on desktop) -->
    <div class="w-full md:w-1/3 flex justify-center md:justify-start order-3 md:order-1">
      <NextRecording />
    </div>
    
    <!-- Centered Logo (Order 1 on mobile, 2 on desktop) -->
    <div class="w-full md:w-1/3 flex justify-center order-1 md:order-2">
      <MainHeader />
    </div>
    
    <!-- Clock (Order 2 on mobile, 3 on desktop) -->
    <div class="w-full md:w-1/3 flex justify-center md:justify-end order-2 md:order-3">
      <DigitalClock />
    </div>
  </header>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import DigitalClock from '@/components/DigitalClock.vue';
import NextRecording from '@/components/NextRecording.vue';

export default {
  name: 'UnifiedHeader',
  components: { MainHeader, DigitalClock, NextRecording }
}
</script>